import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {
  AS_ON,
  CURRENT_RATIO,
  DE,
  EBITDA,
  EBITDA_MARGIN,
  GROSS_BLOCK,
  PAT,
  PAT_MARGIN,
  ROCE,
  RONW,
  TOTAL_DEBT,
  TURN_OVER,
  YEAR,
} from "./consts";
import { zodResolver } from "@hookform/resolvers/zod";
import { formValues, schema } from "./validations";
import { useForm } from "react-hook-form";
import {
  useAddMbaplFinancialReportingMutation,
  useGetMbaplFinancialReporting,
} from "@/services";
import { toast } from "sonner";
import { useEffect } from "react";
import moment from "moment";

const useMbaplFinancialReporting = () => {
  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
       
        [YEAR]: "",
        [AS_ON]: "",
        [TURN_OVER]: "",
        [EBITDA]: "",
        [EBITDA_MARGIN]: "",
        [PAT]: "",
        [PAT_MARGIN]: "",
        [GROSS_BLOCK]: "",
        [DE]: "",
        [ROCE]: "",
        [CURRENT_RATIO]: "",
        [TOTAL_DEBT]: "",
        [RONW]: "",
      
      
    },
  });

  const requiredFields = getRequiredFields(schema);

  const { data: financeData, isLoading: isLoadingFinance } =
    useGetMbaplFinancialReporting({});

  useEffect(() => {
  if (financeData?.data) {
    const d = financeData.data;

    form.reset({
      [YEAR]: d.year?.toString() || "",
      [AS_ON]: d.asOn || "",
      [TURN_OVER]: d.turnOver?.toString() || "",
      [EBITDA]: d.ebitda?.toString() || "",
      [EBITDA_MARGIN]: d.ebitdaMargin?.toString() || "",
      [PAT]: d.pat?.toString() || "",
      [PAT_MARGIN]: d.patMargin?.toString() || "",
      [GROSS_BLOCK]: d.grossBlock?.toString() || "",
      [DE]: d.de?.toString() || "",
      [ROCE]: d.roce?.toString() || "",
      [CURRENT_RATIO]: d.currentRatio?.toString() || "",
      [TOTAL_DEBT]: d.totalDebt?.toString() || "",
      [RONW]: d.ronw?.toString() || "",
    });
  }
}, [financeData]);


  const { mutate: addInfo, isPending: isAddPending } =
    useAddMbaplFinancialReportingMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.issues?.error === "string"
            ? error?.response?.data?.issues?.error
            : typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong",
          {
            className: "!bg-red-500 !text-white",
          }
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        toast.success("Financial Reporting Added Successfully", {
          className: "!bg-green-600 !text-white",
        });
      },
    });

    const onSubmit = (data: any) => {
      let cleaned = removeEmptyFields(data);
      cleaned = setEmptyFieldsToNull(cleaned);

      const payload = {
        ...cleaned,
        [AS_ON]: cleaned[AS_ON]
          ? moment(cleaned[AS_ON]).format("DD MMMM YYYY")
          : "",
      };

      addInfo({ data: payload });
    };


  return {
    form,
    requiredFields,
    onSubmit,
    isLoadingFinance,
    isAddPending,
    
  };
};

export default useMbaplFinancialReporting;
